import PhoneInputView from './PhoneInputView'

export default PhoneInputView
